import { cva } from 'class-variance-authority'

export const subtitleVariants = cva('text-center text-main-foreground-primary text-body-default', {
  variants: {
    subtitleWidth: {
      constrained: 'max-w-sm',
      full: 'max-w-none',
    },
  },
  defaultVariants: {
    subtitleWidth: 'constrained',
  },
})
